import { render, staticRenderFns } from "./OrganisasiPengusahaKabupaten.vue?vue&type=template&id=2a9160b1"
import script from "./OrganisasiPengusahaKabupaten.vue?vue&type=script&lang=js"
export * from "./OrganisasiPengusahaKabupaten.vue?vue&type=script&lang=js"
import style0 from "./OrganisasiPengusahaKabupaten.vue?vue&type=style&index=0&id=2a9160b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports